import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState, AppThunk } from "../../app/store";
import { setLecture } from "./helpAndAssistantApi";
import swal from 'sweetalert';
export interface SetLectureState {
  setlecture: any;
  status: "idle" | "loading" | "failed" | "success";
}

const initialState: SetLectureState = {
  setlecture: [],
  status: "idle",
};

export const GetSetLecture = createAsyncThunk(
  "setLecture",
  async (data: any) => {
    const response = await setLecture(data);
    return response;
  }
);

export const setLectureSlice = createSlice({
  name: "setLecture",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(GetSetLecture.pending, (state) => {
        state.status = "loading";
      })
      .addCase(GetSetLecture.rejected, (state, action) => {
        state.status = "failed";
        swal("Something went wrong!",  "error");
      })
      .addCase(GetSetLecture.fulfilled, (state, action) => {
        state.status = "success";
        state.setlecture = action.payload;
       swal("Record saved success!",  "success");
      });
  },
});

export const {} = setLectureSlice.actions;

export const selectSetLecture = (state: RootState) => {
  return state.setNewLecture.status;
};

export default setLectureSlice.reducer;
